import { Vue, Component } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import LiquorTree from 'liquor-tree'

@Component({
    components: {
        ConfigurationSectionHeader,
        LiquorTree
    }
})
export default class ConfigurationArchiveLevels extends Vue {
    private items!: Array<object>
    private treeOptions!: any
    private selected!: any
    private options!: Array<object>
    private batchSelected!: any
    private batchOptions!: Array<object>

    constructor() {
        super()
        this.items = [
            { text: this.$tc('configuration.sections.archive'),
                id: 1,
                state: { expanded: true },
                children: [
                    { text: 'BP-1',
                        id: 1,
                        state: { expanded: true },
                        children: [
                            { text: 'BP-1-1', id: 1, state: { expanded: true } }
                        ] },
                    { text: 'BP-2',
                        id: 2,
                        state: { expanded: true },
                        children: [
                            { text: 'BP-2-1', id: 1, state: { expanded: true } },
                            { text: 'BP-2-2', id: 2, state: { expanded: true } },
                            { text: 'BP-2-3', id: 3, state: { expanded: true } }
                        ] }
                ] }
        ]
        this.treeOptions = {
            checkbox: true,
            autoCheckChildren: false,
            parentSelect: true,
            checkOnSelect: true
        }
        this.selected = { value: 'a', text: this.$tc('configuration.archive.samples') }
        this.options = [
            { value: 'a', text: this.$tc('configuration.archive.samples') },
            { value: 'b', text: this.$tc('configuration.archive.paraffinBlocks') },
            { value: 'c', text: this.$tc('configuration.archive.frozenBlocks') },
            { value: 'd', text: this.$tc('configuration.archive.slides') }
        ]
        this.batchSelected = { value: 'a', text: this.$tc('configuration.archive.none') }
        this.batchOptions = [
            { value: 'a', text: this.$tc('configuration.archive.none') },
            { value: 'b', text: this.$tc('configuration.archive.all') },
            // TODO Front: mocked data, necessary to improve when development
            { value: 'c', text: `${this.$tc('configuration.archive.level')} 1` },
            { value: 'd', text: `${this.$tc('configuration.archive.level')} 2` },
            { value: 'd', text: `${this.$tc('configuration.archive.level')} 3` }
        ]
    }
}
